import clsx from "clsx";
import { Link } from "react-router-dom";

import ImageWithFallback from "../../../components/Common/ImageWithFallback";
// import Progress from "src/components/Common/Progress";

export type BadgeCardProps = {
  id: number;
  name: string;
  image: string;
  isAcheived?: boolean;
};

const BadgeCard = ({ id, name, image, isAcheived }: BadgeCardProps) => {
  return (
    <Link
      className="flex h-full flex-col items-center gap-2"
      to={`/gamification/badgeDetails/${id}`}
    >
      <div className="aspect-square size-full overflow-hidden rounded-xl border border-mainTextColor/40">
        <ImageWithFallback
          alt={name}
          className={clsx("aspect-square w-full", isAcheived && "grayscale")}
          src={image}
        />
        {/* {progress ? <Progress percentage={60} /> : <div className="h-1" />} */}
      </div>
      <p
        className={clsx(
          "font-semibold",
          isAcheived ? "text-mainTextColor/60" : "text-mainTextColor",
        )}
      >
        {name}
      </p>
    </Link>
  );
};

export default BadgeCard;
